import { Input, Select, SelectItem, DateRangePicker } from "@heroui/react";
import { parseDate } from "@internationalized/date";
import { FilterCard } from "@/components/data-table";

/**
 * Filter component for Purchase Order Return page
 *
 * @param {Object} filterOptions - Options for select filters
 *   - approvalStatuses: Array of { value, title }
 */
const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const { approvalStatuses = [] } = filterOptions;

    // Handle clear - reset to initial values
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* No. Retur */}
            <Input
                label="No. Retur"
                placeholder="Cari nomor retur..."
                value={pending.return_number || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        return_number: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Status Approval */}
            <Select
                label="Status Approval"
                placeholder="Pilih status"
                selectionMode="multiple"
                selectedKeys={
                    new Set(
                        Array.isArray(pending.approval_status_id)
                            ? pending.approval_status_id.map(String)
                            : [],
                    )
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        approval_status_id: Array.from(keys),
                    }))
                }
                variant="flat"
            >
                {approvalStatuses.map((s) => (
                    <SelectItem key={String(s.value)} value={s.value}>
                        {s.title}
                    </SelectItem>
                ))}
            </Select>

            {/* Periode Retur - DateRangePicker */}
            <DateRangePicker
                label="Periode Retur"
                value={
                    pending.date_from && pending.date_to
                        ? {
                              start: parseDate(pending.date_from),
                              end: parseDate(pending.date_to),
                          }
                        : null
                }
                onChange={(value) => {
                    if (value) {
                        setPending((prev) => ({
                            ...prev,
                            date_from: value.start.toString(),
                            date_to: value.end.toString(),
                        }));
                    } else {
                        setPending((prev) => ({
                            ...prev,
                            date_from: "",
                            date_to: "",
                        }));
                    }
                }}
                variant="flat"
            />
        </FilterCard>
    );
};

export default FilterData;
